module.exports = __webpack_public_path__ + "img/VectorRed.fb614151.svg";